import React, { Component } from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { processResponse } from '../../../../utilities/processResponse'

export default class PlaceholderItem extends Component {

    render() {
        const { configuration } = this.props;
        return (
            <Container>
                <Row>
                    <Col id={`ScrollDiv_${configuration.key !== undefined ? configuration.key:null}`} md={12} className={`text-center ${configuration.cssClass}`}>
                        <span dangerouslySetInnerHTML={{__html:processResponse(configuration.itemText)}}></span>
                    </Col>
                </Row>
            </Container>
        )
    }
}
